/* eslint-disable indent */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/auth/Login'
import ClientArea from '@/components/clients/List'
import ClientForm from '@/components/clients/Form'
import ClientSearch from '@/components/clients/Search'
import VoucherArea from '@/components/vouchers/List'
import VoucherSearch from '@/components/vouchers/Search'
import SalesArea from '@/components/sales/List'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/voucher',
            name: 'Home',
            component: Home,
            children: [
                {
                    path: '/client',
                    name: 'ClientArea',
                    component: ClientArea
                },
                {
                    path: '/client/search',
                    name: 'ClientSearch',
                    component: ClientSearch
                },
                {
                    path: '/client/register',
                    name: 'ClientRegister',
                    component: ClientForm,
                    meta: {
                        auth: {roles: [2, 3], forbiddenRedirect: '/forbidden'}
                    }
                },
                {
                    path: '/client/edit/:id',
                    name: 'ClientEdit',
                    component: ClientForm,
                    meta: {
                        auth: {roles: [2, 3], forbiddenRedirect: '/forbidden'}
                    }
                },
                {
                    path: '/voucher',
                    name: 'VoucherArea',
                    component: VoucherArea
                },
                {
                    path: '/voucher/search',
                    name: 'VoucherSearch',
                    component: VoucherSearch
                },
                {
                    path: '/sales',
                    name: 'SalesArea',
                    component: SalesArea
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js